import { Backdrop, CircularProgress } from '@mui/material'

export default function FullscreenLoader({ show }: { show: boolean }) {
  return (
    <Backdrop data-testid={'fullscreen-loader'} open={show} sx={{ zIndex: 100, color: 'white' }}>
      <CircularProgress color="secondary" size={80} thickness={5} sx={{ opacity: '.75' }} />
    </Backdrop>
  )
}
